var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_262_13869",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
          },
        },
        [_c("rect", { attrs: { width: "20", height: "20", fill: "#D9D9D9" } })]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_262_13869)" } }, [
        _c("path", {
          attrs: {
            d: "M7.25 13.5002H3.75C3.5375 13.5002 3.35938 13.428 3.21563 13.2835C3.07188 13.1389 3 12.9598 3 12.7462V12.3127C3 12.2016 3.02083 12.1009 3.0625 12.0106C3.10417 11.9203 3.15972 11.8405 3.22917 11.771L5 10.0002V4.50019H4.75C4.5375 4.50019 4.35938 4.42874 4.21563 4.28582C4.07188 4.1429 4 3.96582 4 3.75457C4 3.54332 4.07188 3.36478 4.21563 3.21894C4.35938 3.07311 4.5375 3.00019 4.75 3.00019H7.77083C7.98333 3.00019 8.16146 3.07165 8.30521 3.21457C8.44896 3.35748 8.52083 3.53457 8.52083 3.74582C8.52083 3.95707 8.44896 4.13561 8.30521 4.28144C8.16146 4.42728 7.98333 4.50019 7.77083 4.50019H6.5V10.0002C6.5 10.1977 6.46528 10.386 6.39583 10.565C6.32639 10.744 6.21528 10.9099 6.0625 11.0627L5.125 12.0002H11.25C11.4625 12.0002 11.6406 12.0717 11.7844 12.2146C11.9281 12.3575 12 12.5346 12 12.7458C12 12.9571 11.9281 13.1356 11.7844 13.2814C11.6406 13.4273 11.4625 13.5002 11.25 13.5002H8.75V18.1252C8.75 18.3377 8.67854 18.5158 8.53562 18.6596C8.39271 18.8033 8.21562 18.8752 8.00437 18.8752C7.79313 18.8752 7.61458 18.8033 7.46875 18.6596C7.32292 18.5158 7.25 18.3377 7.25 18.1252V13.5002ZM13 7.00019C13.4167 7.00019 13.7708 6.85436 14.0625 6.56269C14.3542 6.27103 14.5 5.91686 14.5 5.50019C14.5 5.08353 14.3542 4.72936 14.0625 4.43769C13.7708 4.14603 13.4167 4.00019 13 4.00019C12.5833 4.00019 12.2292 4.14603 11.9375 4.43769C11.6458 4.72936 11.5 5.08353 11.5 5.50019C11.5 5.91686 11.6458 6.27103 11.9375 6.56269C12.2292 6.85436 12.5833 7.00019 13 7.00019ZM13.0021 10.0002C13.4312 10.0002 13.8403 9.90992 14.2292 9.72936C14.6181 9.5488 14.9514 9.2988 15.2292 8.97936C15.3264 8.86825 15.3715 8.74672 15.3646 8.61478C15.3576 8.48283 15.2986 8.38214 15.1875 8.31269C14.8542 8.11825 14.5031 7.97589 14.1344 7.88561C13.7656 7.79533 13.3872 7.75019 12.999 7.75019C12.6108 7.75019 12.2326 7.79533 11.8646 7.88561C11.4965 7.97589 11.1458 8.11825 10.8125 8.31269C10.6989 8.37686 10.6392 8.47623 10.6335 8.61082C10.6278 8.7454 10.6736 8.86825 10.7708 8.97936C11.0486 9.2988 11.3826 9.5488 11.7729 9.72936C12.1631 9.90992 12.5728 10.0002 13.0021 10.0002ZM12.9952 11.0002C11.8873 11.0002 10.9444 10.6102 10.1667 9.83019C9.38889 9.05019 9 8.10686 9 7.00019C9 5.8763 9.38889 4.91825 10.1667 4.12603C10.9444 3.3338 11.8889 2.95853 13 3.00019C14.1111 3.04186 15.0556 3.44464 15.8333 4.20853C16.6111 4.97242 17 5.9063 17 7.01019C17 8.11408 16.6095 9.05505 15.8285 9.83311C15.0477 10.6112 14.1033 11.0002 12.9952 11.0002Z",
            fill: "#8796AF",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }